/** The verticals a tenant can enable (tenant-service VERTICAL_KEYS). */
export const ALL_VERTICALS = ['hotels', 'sports', 'concerts', 'restaurants', 'attractions'] as const;
export type Vertical = (typeof ALL_VERTICALS)[number];

/** Each vertical's public home path. */
export const VERTICAL_HOME: Record<Vertical, string> = {
  hotels: '/hotels',
  sports: '/sports',
  concerts: '/concerts',
  restaurants: '/restaurants',
  attractions: '/attractions-experiences',
};

/** First path segment → the vertical that owns it (public URL `/attractions-experiences`). */
const SEGMENT_VERTICAL: Record<string, Vertical> = {
  hotels: 'hotels',
  sports: 'sports',
  concerts: 'concerts',
  restaurants: 'restaurants',
  attractions: 'attractions',
  'attractions-experiences': 'attractions',
};

/** The vertical a pathname belongs to, or undefined for shared pages. */
export function verticalOfPath(pathname: string): Vertical | undefined {
  return SEGMENT_VERTICAL[pathname.split('/')[1] ?? ''];
}

export function isVertical(value: string): value is Vertical {
  return (ALL_VERTICALS as readonly string[]).includes(value);
}
